import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ISpeakingRubricDetailItem } from '../../../models/newSpeaking.model';
import { Table, TableColumnsType } from 'antd';
import Button from '../../Button';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  data?: ISpeakingRubricDetailItem[];

  showModal(evaluationNo: number): void;
}

const SpeakingRubricItemTable: FC<IProps> = ({ data, showModal }) => {
  const { t } = useTranslation();
  const columns: TableColumnsType<ISpeakingRubricDetailItem> = [
    {
      title: t('cbt.speakRubric.column4'),
      dataIndex: 'evaluationType',
      key: 'evaluationType',
      render: (value) => getCommonCodeLabel('TE0007', value, 'ko'),
    },
    {
      title: t('cbt.speakRubric.column1'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('cbt.speakRubric.column5'),
      dataIndex: 'scoreWeight',
      key: 'scoreWeight',
    },
    {
      title: t('common.button.detail'),
      render: ({ evaluationNo }: ISpeakingRubricDetailItem) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small mint"
            onClick={() => showModal(evaluationNo)}
            text={t('common.button.detail')}
          />
        </div>
      ),
    },
  ];

  return (
    <div className='comm-table__area'>
      <Table columns={columns} dataSource={data} />
    </div>
  );
};

export default SpeakingRubricItemTable;
